import Http from '../http'

export default {

  index(company_id, filter={}) {
    // let search = ''
    // const {limit, page, level} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/companies/${company_id}/company_tags`, {params: {...filter}})
  },

  // https://v2.vuetifyjs.com/en/components/combobox/#no-data-with-chips

}
